(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  // Init a single wrapper that HAS the data attribute
  function initWrapper(wrapper) {
    if (!wrapper) return;

    // Add a marker class on wrapper
    if (isMobile()) {
      wrapper.classList.add('is-mobile-slider');
    } else {
      wrapper.classList.remove('is-mobile-slider');
      wrapper.scrollLeft = 0;
    }

    // Tag each direct child as a "card" so CSS can target reliably
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (child && child.nodeType === 1) {
        child.classList.add('mobile-slide-card');
      }
    });
  }

  function initAllIn(root) {
    (root || document)
      .querySelectorAll('[data-grid-section-mobile-slider]')
      .forEach(initWrapper);
  }

  // Storefront load
  document.addEventListener('DOMContentLoaded', function () {
    initAllIn(document);
  });

  // Theme editor: when a section reloads
  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    initAllIn(e.target);
  });

  // Resize between mobile/desktop
  window.addEventListener('resize', function () {
    initAllIn(document);
  });
})();